export { default } from './omitEventHandlers';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/omitEventHandlers/index.js
// module id = 1623
// module chunks = 22